import { WorkingDays } from "@/types/globalTypes";
import DayBar from "./DayBar";

type WorkingDayHoursInputsProps = {
  workingDays: WorkingDays[];
  handleToggle: (day: number) => void;
  handleTimeChange: (
    day: number,
    index: number,
    type: "start" | "end",
    value: string,
  ) => void;
  handleAddTimePeriod: (index: number) => void;
  handleRemoveTimePeriod: (dayIndex: number, periodIndex: number) => void;
};

function WorkingDayHoursInputs({
  workingDays,
  handleToggle,
  handleTimeChange,
  handleAddTimePeriod,
  handleRemoveTimePeriod,
}: WorkingDayHoursInputsProps) {
  return (
    <div className="flex flex-col gap-10 px-1 pb-5 pt-4 md:gap-5">
      {workingDays.map((dayData) => (
        <DayBar
          key={dayData.day}
          handleAddTimePeriod={handleAddTimePeriod}
          handleRemoveTimePeriod={handleRemoveTimePeriod}
          dayData={dayData}
          dayIndex={dayData.day}
          onToggle={handleToggle}
          onTimeChange={handleTimeChange}
        />
      ))}
    </div>
  );
}

export default WorkingDayHoursInputs;
